import { ARTICLE_CHANNELS, RESOURCE_TYPES, ROLE_CONDITIONS, ROLES } from "../../../util/constants";
import { compareUserRolesToAllowedRoles } from "../../../util/functions";
import { setRoles } from "../../authorization/slices";
import { updateBuckeyeLinkData } from "../../graphql/slices/buckeye-link";
import { setChannels } from "../../graphql/slices/content";
import { setRoleType } from "../../graphql/slices/dashboard";
import { setStandardHours } from "../../graphql/slices/hrProfileData";
import { getAffiliations } from "../enums";

const CONSTANTS = {
  get: getAffiliations,
};

const get = `
    ${CONSTANTS.get} {
      affiliations
      standardHours
    }
`;

const constructChannels = (roles = []) => {
  let channels = [
    ARTICLE_CHANNELS[ROLES.STUDENT]
  ]
  const isEmpl = compareUserRolesToAllowedRoles(roles, [...ROLE_CONDITIONS.staffFaculty, ...ROLE_CONDITIONS.nonStandardEmployee])
  if(isEmpl) {
    channels.push(ARTICLE_CHANNELS[ROLES.EMPLOYEE])
  }
  const isAlumni = compareUserRolesToAllowedRoles(roles, ROLE_CONDITIONS.alumni)
  if(isAlumni) {
    channels.push(ARTICLE_CHANNELS[ROLES.ALUMNI])
  }
  channels.push(ARTICLE_CHANNELS[RESOURCE_TYPES.WELLNESS])
  return channels
}

const transformResponse = (response = {}, { dispatch }) => {
  const getAff = response?.data?.[getAffiliations]
  const roles = getAff?.affiliations ?? []
  if(roles?.length) {
    dispatch(setRoles({ roles }))
    dispatch(
      updateBuckeyeLinkData({
        roles
      })
    );
    dispatch(
      setRoleType(roles)
    );
    const channels = constructChannels(roles)
    dispatch(setChannels({
      channels
    }))
  }
  if(getAff?.standardHours) {
    dispatch(setStandardHours(getAff.standardHours))
  }
  return {
    data: {
      //Keeping this to the original `getAffiliations` string for endpoint versioning reasoning. If using useGetAffiliationsQuery, make sure to reference the return data as just getAffiliations
      getAffiliations: roles
    }
  }
}


const source = {
  CONSTANTS,
  QUERIES: {
    get,
  },
  transformResponse
};
  

export default source;
